import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  withStyles,
  Typography,
  Checkbox,
  InputLabel,
  IconButton,
  Button
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import * as ScenarioActions from "../../../store/ScenarioStore";
import ScenarioModal from "./components/ScenarioModal";
import { UserRoleTypeEnum, userInRoles } from "../../../services/authService";
import VerifyRole from "../../../components/VerifyRole";

const styles = theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 1,
    overflowX: "auto"
  },
  table: {
    minWidth: 700
  },
  filterLabel: {
    position: "relative",
    top: 1,
    marginRight: theme.spacing.unit * 1
  }
});

class ScenarioApp extends Component {
  state = {
    filtered: false,
    scenarioModalOpen: false
  };
  componentDidMount() {
    const { requestScenarios } = this.props;
    requestScenarios();
  }

  handleModalClose = scenario => {
    const { requestScenarios } = this.props;
    if (scenario) {
      requestScenarios();
    }
    this.setState({ scenarioModalOpen: false });
  };

  addScenario = () => {
    const { loadScenarioModal } = this.props;
    loadScenarioModal({
      id: 0,
      name: "",
      alias: "",
      active: true
    });
    this.setState({ scenarioModalOpen: true });
  };

  editScenario = id => {
    const { loadScenarioModal, scenarios } = this.props;
    const scenario = scenarios.find(s => s.id === id);

    loadScenarioModal(scenario);
    this.setState({ scenarioModalOpen: true });
  };

  render() {
    const { classes, scenarios, user } = this.props;

    let filteredScenarios = scenarios;
    if (this.state.filtered) {
      filteredScenarios = scenarios.filter(s => s.isActive);
    }

    // let hierarchyMode = userInRoles(user, [UserRoleTypeEnum.Administrator])
    // ? HierarchyMode.EDIT
    // : HierarchyMode.READ;

    return (
      <div>
        <Typography variant="h4" gutterBottom component="h2">
          Scenarios
        </Typography>
        <Checkbox
          checked={this.state.filtered}
          onChange={event => this.setState({ filtered: event.target.checked })}
        />
        <InputLabel className={classes.filterLabel}>Active Filter</InputLabel>
        <VerifyRole requiredRoles={[UserRoleTypeEnum.Administrator]}>
          <IconButton onClick={() => this.addScenario()}>
            <AddIcon />
          </IconButton>
        </VerifyRole>
        <Paper className={classes.root}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Alias</TableCell>
                <TableCell align="center">Active</TableCell>
                <VerifyRole requiredRoles={[UserRoleTypeEnum.Administrator]}>
                  <TableCell align="center">Action</TableCell>
                </VerifyRole>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredScenarios.map(scenario => (
                <TableRow key={scenario.id}>
                  <TableCell component="th" scope="row">
                    {scenario.name}
                  </TableCell>
                  <TableCell>{scenario.alias}</TableCell>
                  <TableCell align="center">
                    <Checkbox checked={scenario.isActive} disabled={true} />
                  </TableCell>
                  <VerifyRole requiredRoles={[UserRoleTypeEnum.Administrator]}>
                    <TableCell align="center">
                      <Button onClick={() => this.editScenario(scenario.id)}>
                        edit
                      </Button>
                    </TableCell>
                  </VerifyRole>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
        {this.state.scenarioModalOpen && (
          <ScenarioModal
            open={this.state.scenarioModalOpen}
            handleClose={this.handleModalClose}
          />
        )}
      </div>
    );
  }
}

ScenarioApp.propTypes = {
  classes: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    scenarios: state.scenarios.scenarios || [],
    user: state.user.user
  };
}

export default connect(
  mapStateToProps,
  dispatch =>
    bindActionCreators(
      Object.assign({}, ScenarioActions.actionCreators),
      dispatch
    )
)(withStyles(styles)(ScenarioApp));
